import CallerNumberInfo from "features/Header/PuzzelTelephone/components/CallerNumberInfo";
import SessionCommand from "features/Header/PuzzelTelephone/components/SessionCommand";
import {
  IqSessionRequestType,
  SessionCommands,
  Status,
} from "features/Header/PuzzelTelephone/components/types";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/typography/TitleStyles";

type Props = {
  req: IqSessionRequestType;
};

const StatusSetup = (props: Props) => {
  const { req } = props;
  const { status, remoteAddress } = req;
  const { t } = useTranslation();

  if (status === Status.Setup) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <Text bold>{t("I spørreanrop")}</Text>
        <CallerNumberInfo status={status} remoteAddress={remoteAddress} />
        <SessionCommand
          command={SessionCommands.ConsultOff}
          requestId={req.id}
        />
        <SessionCommand
          command={SessionCommands.TransferToPhone}
          requestId={req.id}
          destinationPhoneNumber={req.remoteAddress}
        />
      </div>
    );
  }
  return null;
};

export default StatusSetup;
